// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Dátové centrum",
        "pull_refresh": "Stiahnite nadol a osviežiť sa",
        "release_refresh": "Uvoľnenie na obnovenie",
        "refresh_loading": "Načítanie ...",
        "footer_text": "Služby poskytuje spoločnosť Ucloudlink (NASDAQ: UCL)"
    },
    "home": {
        "input_placeholder": "Vyhľadajte krajinu/región",
        "my_flow": "Moje údaje",
        "charge_code": "Kód poukážky",
        "coupons": "Kupóny",
        "local_package": "Miestne údaje",
        "more": "Viac",
        "popular_destination": "Krajina",
        "buy_now": "Kupovať",
        "package_useing": "Aktívny",
        "unused": "Neaktívny",
        "download_app": "Stiahnite si aplikáciu",
        "enter_the_mall_list": "Prejdite do zoznamu obchodov",
        "no_data": "Zatiaľ žiadne údaje",
        "no_data_available": "Nie sú k dispozícii žiadne údaje",
        "copy_success": "Kópia úspešná",
        "copy_fail": "Kópia zlyhala",
        "meritsTitle": "Aké sú výhody?",
        "merits1": "Bez SIM karty & Bez mesačných poplatkov",
        "merits2": "Integrované s topovými 2-3 operátormi pre automatické prepínanie siete",
        "go_buy": "Kúpte si teraz",
        "instant_savings": "Ušetri",
        "expires_in": "Vyprší za",
        "download_app_tips": "Stiahnite aplikáciu pre viac ponúk a zážitkov"
    },
    "packages": {
        "sub_title": {
            "us": "S výnimkou Guamu, Saipan",
            "it": "Vrátane mesta Vatikán, San Marino",
            "va": "Vrátane Talianska, San Marino",
            "sm": "Vrátane Talianska, Vatikánskeho mesta",
            "ma": "Vrátane západnej Sahary",
            "eh": "Vrátane Maroka",
            "ch": "Vrátane Lichtenstein",
            "li": "Vrátane Švajčiarska",
            "fr": "Vrátane Monaka",
            "mc": "Vrátane Francúzska",
            "fi": "Vrátane Alandových ostrovov",
            "ax": "Vrátane Fínska",
            "gu": "Vrátane ostrovov Northern Mariana",
            "mp": "Vrátane Guamu"
        },
        "unlimited_packages": "Neobmedzený dátový balík",
        "normal_packages": "Normálny dátový balík",
        "multi_region_packages": "Viacerých regiónov",
        "regional_data": "Regionálne dáta",
        "high_speed_text": "vysokorýchlostné údaje",
        "infiniteFlow": "Neobmedzené údaje",
        "unLimitData": "Neobmedzený",
        "high_speed_text_year": "vysoká rýchlosť/MP",
        "package_list": "Zoznam balíkov",
        "special_offer": "Sleva",
        "first_month": "1. Mesiac",
        "periodUnit": {
            "day": "deň",
            "month": "mesiac",
            "hour": "Hodina",
            "year": "rok"
        },
        "periodUnits": {
            "day": "deň",
            "month": "mesiace",
            "hour": "Hodina",
            "year": "roky"
        },
        "periodUnitSimp": {
            "day": "d",
            "month": "pre",
            "hour": "h",
            "year": "the"
        },
        "periodUnitMonthly":"Mesačný",
        "periodUnitsSimp": {
            "day": "d",
            "month": "pre",
            "hour": "h",
            "year": "the"
        },
        "unlimited_good_name": {
            "day": "Denný priechod",
            "month": "Mesačný priechod",
            "year": "Ročný priechod"
        },
        "continuousMonth": "Nepretržité mesiace",
        "continuousDay": "Nepretržité dni",
        "continuousYear": "Nepretržité roky",
        "day_invalid": "Vyprší v aktuálnom dni",
        "month_invalid": "Vyprší v aktuálnom mesiaci",
        "immediate_valid": "Účinne okamžite",
        "tomorrow_day_valid": "Účinné od nasledujúceho dňa",
        "tomorrow_month_valid": "Účinné od budúceho mesiaca",
        "detail": {
            "cell_flow": "Údaje",
            "cell_period": "Platnosť",
            "buy_quantity": "Výška",
            "use_area": "Pokrytie",
            "use_intro": "Podmienky",
            "buy_btn": "Objednávka",
            "pay": "Zaplatiť",
            "buy_tips": "Máte balík %@packageName v používaní. Chcete kúpiť tento balík?",
            "haveOrderTips": "Vytvorená objednávka s čakajúcou platbou. Kliknite Potvrdiť pre presun na mojú dátovú stránku！"
        },
        "confirm": {
            "title": "Potvrdenie objednávky",
            "real_pay_amount": "Platená suma",
            "online_payment": "Online platba",
            "create_order_error": "Nastavenie zlyhalo"
        }
    },
    "pay": {
        "result": {
            "loading_order_status": "Získanie stavu objednávky ...",
            "buy_success": "Objednať",
            "buy_pending": "Čakajúce potvrdenie",
            "buy_pending_tip": "Platba v procese ... Ak sa platba nedostala prevedená do 10 minút, kontaktujte nás pre podporu.",
            "get_payment_info_fail": "Získavanie informácií o platbe zlyhalo",
            "cell_package": "Balík",
            "cell_buy_amount": "Medzisúčet",
            "cell_real_amount": "Platená suma",
            "go_to_order_btn": "Choďte do môjho balíka",
            "back_home": "Späť",
            "back_mall": "Späť do nákupného centra",
            "ordersn_empty": "Order Sn nemôže byť prázdny",
            "order_search_error": "Neočakávaná chyba",
            "goodsName": 'Názov produktu'
        },
        "fail": {
            "payment_fail": "Platba zlyhala",
            "back_home": "Späť"
        }
    },
    "CountryGroup": {
        "title": "Krajina",
        "placeholder": "Vyhľadajte krajinu alebo región",
        "clear": "Vyčistiť",
        "history": "História vyhľadávania"
    },
    "PromotionCode": {
        "verification": {
            "title": "Kód poukážky",
            "minititle": "Kód poukážky",
            "input": "Zadajte doplnkový kód",
            "explain": "Tipy: Dotknite sa tlačidla skenovania v pravom hornom rohu a naskenujte QR kód karty voucheru alebo ručne zadajte kód voucheru (citlivé na puzdro), ak to nefunguje.",
            "submit": "Odovzdať",
            "exchange": "Zopakovať",
            "cancel": "Zrušiť",
            "Inquiry": "Určite si vymeníte",
            "ErrorCode": "Chyba nabíjania kódu"
        },
        "recharge_success": {
            "package": "Balík",
            "content": "Úspešne vykúpený",
            "back": "Späť do nákupného centra",
            "view_packets": "Choďte do môjho balíka"
        }
    },
    "order": {
        "state": {
            "inUse": "Aktivovaný",
            "isFirst": "Prioritný",
            "toFirst": "Stanoviť prioritu",
            "inactive": "Neaktivirano"
        },
        "periodUnits": {
            "minute": "minúta",
            "hour": "Hodina",
            "day": "deň",
            "month": "mesiac"
        },
        "useIntro": {
            "tip1": "Neobmedzený dátový balík má vyššiu prioritu ako balík objemových údajov.",
            "tip2": "Priorita využitia bude založená na dátume nákupu rovnakého typu balíka, t. J. Balík s najskorším dátumom nákupu sa použije ako prvý, zatiaľ čo priorita balíkov s jedným regiónom je vyššia ako regionálny balík.",
            "tip3": "Môžete tiež manuálne upraviť prioritu používania paketov rovnakého typu."
        },
        "myFlow": "Moje údaje",
        "remainingFlow": "Dáta vľavo",
        "remainingTime": "Platný ľavý",
        "remainingHighFlow": "Vysokorýchlostné údaje vľavo",
        "validPeriod": "Platnosť",
        "noneFlow": "Žiadny dátový balík",
        "noneFlowTip": "Kúpte si dátový balík a vychutnajte si vysoko kvalitnú sieť",
        "buyPackFlow": "Kúpiť balíčky",
        "checkInvalidFlow": "Skontrolujte balík údajov vypršaného",
        "orderList": {
            "title": "moje rozkazy",
            "amount_paid": "Celkom",
            "device": "Vlastnené zariadenie",
            "order_details": "Podrobnosti objednávky",
            "total_amont": "Medzisúčet",
            "orderSN": "Objednávka č.",
            "createTime": "Čas vytvorenia",
            "cancelTime": "Zatvorený čas",
            "payTime": "Čas objednávky",
            "unsubTime": "Zrušený čas",
            "payMethod": "Spôsob platby",
            "thirdSN": "Transakcia č.",
            "delete": "Odstrániť",
            "cancel": "Zrušiť objednávku",
            "unsub": "Vrátenie peňazí",
            "goto_cancel": "Chcete zrušiť objednávku?",
            "goto_unsubscribe": "Chcete zrušiť odber objednávky?",
            "delete_Tips": "Objednávku nie je možné po vymazaní obnoviť, preto nie je možné vyriešiť vaše problémy so servisom.Naozaj ho chcete odstrániť?",
            "status_success": "Dokončené",
            "status_pending": "Nezaplatené",
            "status_cancel": "ZATVORENÉ",
            "status_unsub": "Zrušené",
            "payMethod_stripe": "Kreditná karta"
          },
    },
    "registerlogin": {
        "create_account_tip":"Vytvorte si účet, začnite exkluzívne skúsenosti",
        "select_country_tip":"Využívanie zariadenia Krajina/región",
        "email_name": "Pošta",
        "phone_name": "Telefon",
        "email_address": "E -mailová adresa",
        "password": "heslo",
        "country": "krajina",
        "select_country": "Vyberte si krajinu",
        "cancel": "Zrušiť",
        "confirm": "Isto",
        "please_enter": "Zadajte 6-20 znakov (kombinácia písmen, čísel alebo symbolov)",
        "select_country_tips": "Výber krajiny je určený na prezeranie miestnych balíkov. Po registrácii sa nedá zmeniť. Potvrďte prosím!",
        "global_roaming": "Medzinárodný kód domény",
        "phone_number": "telefónne číslo",
        "agree": "súhlasiť",
        "user_agreement": "Dohoda o používateľovi",
        "and": "a",
        "privacy_policy": "Zásady ochrany osobných údajov",
        "register_login": "Prihláste sa alebo prihláste sa",
        "login_error": "Počet prihlásení je príliš častý, skúste to znova neskôr!",
        "register_error": "Počet registrácií je príliš častý, skúste to znova neskôr!",
        "forgot_pwd": "Zabudnite na heslo",
        "app_tips": "Po prenosu tega računa se prijavite v aplikacijo s tem računom, da dostopate do več funkcij.",
        "download_app": "Prejdite na stiahnutie aplikácie",
        "rememberPwd": "Pamätajte na heslo",
        "third_login": "Pokračovať",
        "agreement_tips": "Skontrolujte políčko Užívateľskej zmluvy a politiky ochrany osobných údajov",
        "selectCountry_tips": "Prosím, všimnite si, že registrovaná krajina bude mať priamy vplyv na nasledujúce spôsoby platby a meny, vyberte podľa svojich potrieb.",
        "login_error_cancel": "Používateľ zrušil prihlásenie",
        "login_error_auth": "Povoliť vyskakovacie okná v nastaveniach prehliadača",
        "device_tips": "Zariadenie čaká na aktiváciu. Spracovanie do 24 hodín."
    },
    "forgotPwd": {
        "forgot_pwd": "Zabudnite na heslo",
        "email_address": "E -mailová adresa",
        "next": "Najbližší",
        "email_has_been_sent": "Poslali sme e -mail na adresu %@email. Kliknite na odkaz a postupujte podľa krokov a získajte svoje heslo.",
        "have_retrieved_it": "Našiel som to",
        "unable_to_receive_email": "Nemôžete dostať e -mail? Skontrolujte, či existujú e -maily z %@email v rámci vášho adresára spamu a vymazaného pošty",
        "or": "alebo",
        "resend": "Zopakovať",
        "global_roaming": "Medzinárodný kód domény",
        "phone_number": "telefónne číslo",
        "verification_code_has_been_sent": "Poslali sme overovací kód na:",
        "verification_code": "Overovací kód",
        "no_verification_code_received": "Nedostal overovací kód?",
        "please_enter": "Zadajte 6-20 znakov (kombinácia písmen, čísel alebo symbolov)",
        "reset_password": "Obnovenie hesla",
        "reset_successful": "Úspešne reset"
    },
    "coupons": {
        "coupons_name": "Kupóny",
        "no_coupons": "Zatiaľ žiadne kupóny",
        "no_data": "Zatiaľ žiadne údaje",
        "applicable_to_the_following": "Kupóny sú vhodné pre nasledujúci dátový balík"
    },
    "digital":{
        "title":"Zariadenie SN",
        "purchased":"Moje nákupy",
        "viewAll":"Viac",
        "skinStore":"Obchod s výrobkami",
        "completed":"Nákupný",
        "goBuy":"Nákup",
        "order": {
          "title":"Zakúpené objednávky"
        },
        "detail": {
          "describe":"Opis"
        }
    },
    "viewPL": {
        "other": 'ostatní'
    },
    "invalidFlow": {
        "stateName": "Stav",
        "state": {
            "NOT_ACTIVATED": "Neaktivirano",
            "IN_USING": "Dostupný",
            "USE_END": "Vyčerpaný",
            "EXPIRE": "Vypršaný",
            "TRANSFER": "Prenos",
            "UNSUBSCRIBE": "Zrušiť",
            "VALID": "Oprávnený",
            "INVALID": "Neplatný",
            "EXCHANGE_POINTS": "Odkup točk"
        },
        "noneFlow": "Žiadny dátový balík vypršaných",
        "pageName": "Vypršaný dátový balík"
    },
    "flowDetail": {
        "title": "Údaje",
        "flow": "Údaje",
        "validTime": "Platné štarty",
        "invalidTime": "Platný",
        "coverage": "Pokrytie",
        "useIntro": "Podmienky",
        "purchaseTime": "Zakúpené na",
        "subtotal": "Medzisúčet",
        "status": "Stav",
        "cancel": "Zrušiť",
        "buyAgain": "Kúpte si to znova",
        "validity": "Platnosť",
        "tip": "Oznámenie",
        "cancelTip": "Ste si istý, že chcete tento balík vrátiť?",
        "dataLeft": "Dáta vľavo"
    },
    "netError": {
        "try_again": "Skúste to znova",
        "net_error": "Žiadna sieť",
        "try_again_desc": "Skontrolujte nastavenie siete a skúste to znova"
    },
    "loadFail": {
        "try_again": "Skúste to znova",
        "load_fail": "Načítanie zlyhalo",
        "load_fail_desc": "Načítavanie údajov zlyhalo, skúste to znova",
        "IMEI_Not_Exist": "Imei neexistuje, skúste vstúpiť z pravého vchodu",
        "Project_Not_Exist": "Vyskytuje sa chyba. Kontaktujte zákaznícky servis. (01)",
        "commonError": "Vyskytuje sa chyba. Kontaktujte zákaznícky servis."
    },
    "settlement_Easy_and_convenient": "Ľahké a pohodlné",
    "settlement_Great_deal": "Veľa",
    "settlement_Safe_and_secure": "Bezpečné a bezpečné",
    "settlement_Autopay_service_regulation": "Regulácia služieb Autopay",
    "settlement_Read": "Čítanie",
    "settlement_No_coupon": "Ni na voljo kupona",
    "settlement_Subtotal": "Medzisúčet",
    "settlement_Coupon": "Kupóny",
    "settlement_TOTAL": "Skupaj",
    "settlement_promotion_tip": "Propagačná ponuka nemožno použiť v spojení s žiadnymi kupónmi",
    "settlement_coupon_tip": "Kupón sa nedá použiť v spojení s inými propagačnými ponukami",
    "member_myFlow_noList": "Brez podatkov",
    "detail_se_content": "Varen, enostaven in priročen način. Kadar koli se lahko odjavite",
    "Enter_Promo_code": "Promocijska koda",
    "Enter_Promo_Coupon": "Kupóny",
    "settlement_Not_used_coupon":"kupón sa nepoužíva",
    "settlement_Available_coupon": "Dostupný",
    "settlement_Unavailable_coupon":"Nedostupný",
    "please_Enter_Promo_code": "Prosimo, vnesite promocijsko kodo",
    "please_Select_Coupon_use":"Vyberte kupón, ktorý chcete použiť.",
    "Buy_Now": "Kupovať",
    "Dont_Use_Any": "Nepoužívajte žiadne",
    "settlement_confirm": "Potvrdiť",
    "settlement_tips": "Potvrdiť",
    "flowDetail_unsubscribe": "Odber",
    "flowDetail_unsubscribed": "Zrušený",
    "flowDetail_isCancelPackage": "Odhláste tento balík?",
    "flowDetail_confirmAgreementUnsubscribe": "Po odhlásení sa nemôžete mať veľa. Si si istý, že sa chcete odhlásiť?",
    "flowDetail_cancel": "Zrušiť",
    "flowDetail_cancelSuccess": "Úspešne sa odhláste",
    "packages_detail_promotion": "Propagácia",
    "orderTips":{
        "iDay" : "deň",
        "iDays" : "dni",
        "iMonth" : "mesiac",
        "iMonths" : "mesiace",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Pri prvom nákupe, platiť %@money/%@periodSymbol neskôr, Môžete sa kedykoľvek odhlásiť",
        'Monthly_discount':"Ušetrite %@saveMoney každé %@period! Môžete sa kedykoľvek odhlásiť",
        'Ordinary_monthly_package':"Bezpečný, ľahký a pohodlný spôsob. Môžete sa kedykoľvek odhlásiť",
        "AlreadyPurchased":'Ospravedlňujeme sa, že sa v súčasnosti môžete prihlásiť iba na jeden dátový balík. Odhláste sa od “%@” a prihláste sa neskôr do akéhokoľvek balíka, ktorý chcete po jeho skončení platnosti.',
        "Contract_recommendation_First":'<label>S službou Autopay, pri prvom nákupe, platiť iba</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Môžete sa kedykoľvek odhlásiť'
        +'<a class="btn">Predplatiť ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>So službou AutoPay Pay iba</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Môžete sa kedykoľvek odhlásiť'
        +'<a class="btn">Predplatiť ></a></p>',
        "Contract_recommendation_General":"<label>So službou AutoPay</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Bezpečný, ľahký a pohodlný spôsob. Môžete sa kedykoľvek odhlásiť'
        +'<a href="javascript:;" class="btn">Predplatiť ></a></p>',
        'BanlanceDoubleCheck':'Ste si istý, že chcete platiť zostatkom?',
    },
    feedback: {
        title: "spätná väzba",
        placeholder: "Zadajte do krajiny, ktorú chcete navštíviť, alebo akékoľvek ďalšie otázky, a my budeme čo najskôr splniť vaše potreby!",
        submit: "Predložiť",
        submit_success: "Úspešne odoslané",
        other_opinions: "Ostatné názory"
    },
    view_country_input: 'Zadajte svoj účet',
    "select_package": {
        "title": "Vybrať Dáta",
        "allPackage": "Všetky Dáta",
        "type": "Typ",
        "flow": "Dáta",
        "month_package": "Mesiacný plán",
        "flow_package": "Datový balíček",
        "time": "Trvanie",
        "period": "Cyklus",
        "auto_debit": "Info Autodebet",
        "auto_subscribe": "Auto-Obnovenie",
        "detail": "Podrobnosti Dát",
        "carrier": "Podporované Operátory",
        "country": "Pokryté Krajiny",
        "notice": "Návod na nákup"
    }
}